{
  "title": "共享您的位置可以加快签到流程",
  "body": "很抱歉，如果无法获取您的位置信息，我们将无法完成您的签到。请授予位置访问权限以继续。我们仅将您的位置信息用于仓库签到，不会存储或与第三方共享您的位置信息。",
  "shareLocation": "共享我的位置"
}
